import React from "react";
import GridItem from "../../components/AdminPortal/Dashboard/GridItem";

const AdminDashboard = () => {
  const links = [
    { id:"1", title: "Videos", colorClass: "text-yellow-500", link:"videos" },
    { id:"2", title: "Assignment", colorClass: "text-red-500", link:"assignments"},
    { id:"3", title: "Quizzes", colorClass: "text-indigo-500", link:"quizzes" },
    { id:"4", title: "Assginment Marks", colorClass: "text-green-500", link:"assignment-marks" },
  ];

  return (
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-7xl px-5 lg:px-0">
        <div className="px-3 md:lg:xl:px-40  py-20 bg-opacity-10">
          <div className="grid grid-cols-1 md:grid-cols-2  gap-6 p-8">
            {links.map((item) => <GridItem key={item.id} item={item}/>)}

          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminDashboard;
